import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledAssistantQuery = styled(Box)`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  row-gap: ${props => props.theme.layout('1sp')};

  .AssistantQuery {
    &-content {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      width: 100%;
      overflow: hidden;
      max-height: fit-content;
      position: relative;
      background-color: ${props => props.theme.property('palette.background.paper')};
    }
    
    &-conversation {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      overflow: hidden;
      gap: ${props => props.theme.layout('3sp')};
      padding: 0 ${props => props.theme.spacing(2)};
      
      .ListWrapper {
        &-content {
          height: unset;
          max-height: 100%;

          .DataList-list {
            padding: ${props => props.theme.spacing(2)} 0;
            scroll-margin-top: ${props => props.theme.spacing(2)};
            scroll-margin-bottom: ${props => props.theme.spacing(2)};

            .ListItem {
              &:not(:first-child, :last-child) {
                scroll-margin-top: ${props => props.theme.spacing(1.5)};
                scroll-margin-bottom: ${props => props.theme.spacing(1.5)};
              }
            }
          }
        }
      }

      &-navigation {
        display: flex;
        width: 100%;
        position: relative;

        .List {
          width: 100%;
          padding: 0 ${props => props.theme.spacing(2)} ${props => props.theme.spacing(0.5)} ${props => props.theme.spacing(2)};
          overflow-y: scroll;

          .ListItem {
            padding: 0;

            .Button {
              text-wrap: nowrap;
            }
          }
        }
      }
    }

    &-form {
      width: 100%;
      .Form-fields {
        .FormControl {
          .MuiInputBase-root {
            background-color: ${props => props.theme.property('palette.background.paper')};
          }
        }
      }
    }
    
    &-footer {
      display: flex;
      width: 100%;
    }
    
    &-actions {
      display: flex;
      width: 100%;
      justify-content: space-between;
      
      &-left, &-right {
        display: flex;
        gap: ${props => props.theme.layout('1sp')};
        
        .Button {
          white-space: nowrap;
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledAssistantQuery.propTypes = {
  theme: PropTypes.object
};

export default StyledAssistantQuery;
